import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { DesignLayout } from '@common/DesignLayout';
import { RoutePath } from '@components/AppRouter/constants';
import { useCheckFromDictionaryCard } from '@src/utils/hooks/useCheckFromDictionaryCard';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import { useAuditView } from '../../hooks/useAuditView';
import { Table } from './Table';

export const ReportGroups = observer(() => {
  const { fetch, clear } = reportGroupsStore;

  const isBack = useCheckFromDictionaryCard(RoutePath.DICTIONARY_REPORT_GROUPS);

  useAuditView('Группы отчетности');

  useEffect(() => {
    void (async () => {
      await fetch();
    })();
  }, [fetch]);

  useEffect(() => {
    if (!isBack) clear();
  }, [clear, isBack]);

  return (
    <DesignLayout scrollEnable>
      <Table />
    </DesignLayout>
  );
});
